import { NodeUI } from 'modules/workflows/components/Node/types'
import ConditionalNodeSidepanel from 'modules/workflows/components/Sidepanel/ConditionalNodeSidepanel'
import TaskNodeSidepanel from 'modules/workflows/components/Sidepanel/TaskNodeSidepanel'
import TriggerNodeSidepanel from 'modules/workflows/components/Sidepanel/TriggerNodeSidepanel'
import { VariableSelectorsMapping } from 'modules/workflows/components/Sidepanel/VariableSelectorTypes'
import {
  BuildingBlock,
  WorkflowBuildingBlocksBox,
} from 'modules/workflows/components/WorkflowBuildingBlocksBox'

import { ApprovalNodeSidepanel } from './ApprovalNodeSidepanel'
import { SidePanelFormProvider } from './SidePanelFormProvider'

type Props = {
  showBuildingBlock: boolean
  selectedNode: NodeUI | undefined
  buildingBlocks: BuildingBlock[]
  variableSelectors: VariableSelectorsMapping | undefined
}
export const Sidepanel = ({
  showBuildingBlock,
  selectedNode,
  buildingBlocks,
  variableSelectors,
}: Props) => {
  return (
    <>
      {showBuildingBlock && <WorkflowBuildingBlocksBox buildingBlocks={buildingBlocks} />}

      {selectedNode && (
        <SidePanelFormProvider selectedNode={selectedNode} key={selectedNode.id}>
          {selectedNode.type === 'trigger' && (
            <TriggerNodeSidepanel key={selectedNode.id} node={selectedNode} />
          )}
          {selectedNode.type === 'condition' && (
            <ConditionalNodeSidepanel
              key={selectedNode.id}
              node={selectedNode}
              variableSelectors={variableSelectors}
            />
          )}
          {selectedNode.type === 'approvals' && (
            <ApprovalNodeSidepanel key={selectedNode.id} node={selectedNode} />
          )}
          {selectedNode.type === 'task' && (
            <TaskNodeSidepanel key={selectedNode.id} node={selectedNode} />
          )}
        </SidePanelFormProvider>
      )}
    </>
  )
}
